<template>
  <div class="container">
    <div class="row pt-4" v-if="landInfo && landInfo.length > 0">
      <div class="col-md-12">
        <table class="table">
          <thead class="fp-header">
            <th>PID</th>
            <th>Address</th>
            <th>Status</th>
            <th>Registration Type</th>
            <th>Sales Price</th>
            <th>Registered Owner</th>
            <th>Date</th>
          </thead>
          <tbody class="fp-body">
            <tr v-for="(value, key) in landInfo" :key="key">
              <td>{{ value.pid }}</td>
              <td>{{ value.address }}</td>
              <td>{{ value.status }}</td>
              <td>
                <template v-if="selectedDateMap[key] && selectedDateMap[key].selectedDate">
                  {{
                    value.reg[selectedDateMap[key].selectedDate]
                      .registration_type
                  }}
                </template>
              </td>
              <td>
                <template v-if="selectedDateMap[key] && selectedDateMap[key].selectedDate">
                  {{ value.reg[selectedDateMap[key].selectedDate].sale_price }}
                </template>
              </td>
              <td>
                <template v-if="selectedDateMap[key] && selectedDateMap[key].selectedDate">
                  {{ value.reg[selectedDateMap[key].selectedDate].purchaser }}
                </template>
              </td>
              <td v-if="selectedDateMap[key] && selectedDateMap[key]">
                <b-form-select v-model="selectedDateMap[key].selectedDate" @change="selectedDate($event, key)">
                  <b-form-select-option v-for="(reg, regKey) in value.reg" :key="regKey + key" :value="regKey">
                    {{ regKey }}
                  </b-form-select-option>
                </b-form-select>
              </td>
              <td v-else></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row pt-4" v-if="
      groupInfo.ptc.display_total && ['admin'].includes(current_user.role)
    ">
      <div class="col-md-12">
        <table class="table">
          <thead class="fp-header">
            <th></th>
            <th>Units</th>
            <th>Floor Area</th>
            <th>Floor Area (gross)</th>
            <th>FSR/FAR</th>
            <th>Parking</th>
            <th>Studio</th>
            <th>1-bed</th>
            <th>2-bed</th>
            <th>3-bed</th>
            <th>4-bed</th>
          </thead>
          <tbody class="fp-body">
            <tr v-for="(value, key) in totalInfo" :key="key">
              <td>{{ key }}</td>
              <td>{{ value.total_units ? value.total_units : "-" }}</td>
              <td>{{ value.total_floor_area | numFormat }}</td>
              <td>{{ value.gross | numFormat }}</td>
              <td>{{ value.total_fsr ? value.total_fsr : "-" }}</td>
              <td>{{ value.total_parking ? value.total_parking : "-" }}</td>
              <td>{{ value.total_studio ? value.total_studio : "-" }}</td>
              <td>{{ value.total_1_bed ? value.total_1_bed : "-" }}</td>
              <td>{{ value.total_2_bed ? value.total_2_bed : "-" }}</td>
              <td>{{ value.total_3_bed ? value.total_3_bed : "-" }}</td>
              <td>{{ value.total_4_bed ? value.total_4_bed : "-" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-button variant="primary" class="mb-2" v-b-modal.total-modal
      v-if="Object.entries(utcInfo).length > 1">Total</b-button>
    <b-tabs content-class="mt-3">
      <b-tab v-for="(row, key_i, row_index) in utcInfo" :key="key_i" :title="'Lot ' + ++row_index"
        :active="shouldActive(key_i)">
        <template #title>
          <span v-if="shouldActive(key_i)" class="badge badge-vb-secondary" style="font-size: medium">{{ "Lot " +
            row_index }}</span>
        </template>
        <div class="mt-20">
          <div class="badge badge-vb-tertiary font-weight-bold" style="font-size: large"></div>
          <div class="row align-items-center">

            <b-table-simple hover small caption-top>
              <b-thead>
                <b-tr>
                  <b-th> Project Name </b-th>
                  <b-th> Project Type </b-th>
                  <b-th> Storey </b-th>
                  <b-th> Project Status </b-th>
                </b-tr>
              </b-thead>
              <b-tbody v-for="(item, index) in row" :key="index">
                <b-tr>
                  <b-td @click="showMarketDetails(item.project_name + index)"> {{ item.project_name }}
                    <font-awesome-icon v-if="showBlendedPsf(item.project_split) && item.project_split.length > 1"
                      :icon="selectedProject ? ['fas', 'caret-up'] : ['fas', 'caret-down']" class="mr-2" />
                  </b-td>
                  <b-td> {{ item.project_type }} </b-td>
                  <b-td>
                    <b-badge variant="vb-secondary" style="font-size: medium" v-if="item.project_storey">{{
                      item.project_storey }}-Storey</b-badge>
                  </b-td>
                  <b-td class="row">
                    <template v-for="(split, split_index) in item.project_split">

                      <div class="col">
                        <b-link style="text-decoration: underline" v-if="
                          ['admin'].includes(current_user.role) ||
                          (['market strata', 'market rental'].includes(
                            split.gut.toLocaleLowerCase()
                          ) &&
                            [
                              'in planning',
                              'selling soon',
                              'leasing soon',
                              'now selling',
                              'now leasing',
                              'sold out',
                              'leased out',
                            ].includes(
                              split.status.toLocaleLowerCase()
                            ))
                        " :href="split.link" class="small btn text-primary">{{ split.status }}</b-link>
                        <b-link class="btn small" v-else>{{
                          split.status
                        }}</b-link> <br />
                        <span>
                          {{ split.gut }}
                        </span> <br />
                        <i v-if="split.units">
                          {{ split.units }} units
                        </i>
                      </div>
                    </template>
                  </b-td>
                </b-tr>
                <b-tr v-show="selectedProject == item.project_name + index">
                  <td v-if="showBlendedPsf(item.project_split) && item.project_split.length > 1" colspan="5">
                    <div class="row justify-content-between align-items-center mx-4">
                      <h5 class="mb-3">Market Details</h5>
                      <template v-if="showBlendedPsf(item.project_split) && item.project_split.length > 1 && item.project_split.some(i => ['Below-Market Rental','Market Rental'].includes(i.gut))">
                        <div class="text-center badge badge-vb-purple">
                          <h3 class="display-4 font-weight-bold">
                            ${{ showBlendedPsf(item.project_split) }}
                          </h3>
                          <p class="mb-0 text-muted small">Blended PSF</p>
                        </div>
                      </template>
                    </div>

                    <hr class="my-4" />
                    <b-row v-for="(project, proj_index) in getLatestHistory(item.project_split)" :key="proj_index">
                      <div class="col">
                        <p class="mb-30 text-muted small"></p>
                        <p class="font-weight-bold">{{ project.gut }}</p>
                      </div>
                      <template v-if="project.attr">
                        <div class="col">
                          <p class="mb-1 text-muted small">Avg Size</p>
                          <p v-if="project.attr['avg_size'] != 0">{{ project.attr['avg_size'] }}sq.ft</p>
                          <p v-else>-</p>
                        </div>
                        <div class="col">
                          <p class="mb-1 text-muted small">Avg Price</p>
                          <p v-if="project.attr['avg_price']">${{ project.attr['avg_size'] && project.attr['avg_psf'] ? Math.round(project.attr['avg_size'] * project.attr['avg_psf']).toLocaleString() : '-'
                            }}</p>
                          <p v-else>-</p>
                        </div>
                        <div class="col">
                          <p class="mb-1 text-muted small">Avg $PSF</p>
                          <p v-if="project.attr['avg_psf']">${{ project.attr['avg_psf'] }}</p>
                          <p v-else>-</p>
                        </div>
                        <div class="col">
                          <p class="mb-1 text-muted small">Net $PSF</p>
                          <p v-if="project.attr['total_net_psf']">${{ project.attr['total_net_psf'] }}</p>
                          <p v-else>-</p>
                        </div>
                      </template>
                      <template v-else>
                        <div class="col">
                          <p class="mb-1 text-muted small">Avg Size</p>
                          <p class="font-weight-bold">-</p>
                        </div>
                        <div class="col">
                          <p class="mb-1 text-muted small">Avg Price</p>
                          <p class="font-weight-bold">-</p>
                        </div>
                        <div class="col">
                          <p class="mb-1 text-muted small">Avg $PSF</p>
                          <p class="font-weight-bold">-</p>
                        </div>
                        <div class="col">
                          <p class="mb-1 text-muted small">Net $PSF</p>
                          <p class="font-weight-bold">-</p>
                        </div>
                      </template>
                    </b-row>
                  </td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </div>
      </b-tab>
    </b-tabs>

    <b-modal id="total-modal" title="General Unit Type Total" striped ok-only>
      <b-table striped hover :items="totals"></b-table>
    </b-modal>
  </div>
</template>
<script>
import { BModal, VBModal } from "bootstrap-vue";
import RpdTable from "../../components/common/RpdTable.vue";
import { useUserStore } from "../../store/UserStore";
import { mapStores, mapState } from "pinia";
export default {
  props: ["groupInfo", "location", "utcInfo", "fid"],
  components: {
    "b-modal": BModal,
    RpdTable,
  },
  directives: {
    "b-modal": VBModal,
  },
  computed: {
    ...mapState(useUserStore, ["current_user"]),
    blendedAveragePsf() {
      let totalWeightedPsf = 0;
      let totalUnits = 0;
      let showBlendedPsf = true
      for (const dataKey in this.utcInfo) {
        if (Object.prototype.hasOwnProperty.call(this.utcInfo, dataKey)) {
          const entry = this.utcInfo[dataKey];
          Object.entries(entry).forEach(item => {
            if (Object.entries(item[1].attr_history).length <= 0) {
              showBlendedPsf = false
              return
            }

            for (const splitItem of item[1].project_split) {
              if (splitItem.attr && splitItem.units) {
                const attrKeys = Object.keys(splitItem.attr);
                if (attrKeys.length > 0) {
                  const lastAttrKey = attrKeys[attrKeys.length - 1];
                  const lastAttr = splitItem.attr[lastAttrKey];
                  const units = parseFloat(splitItem.units);
                  const avgPsf = parseFloat(lastAttr.avg_psf);
                  if (!isNaN(units) && !isNaN(avgPsf)) {
                    totalWeightedPsf += units * avgPsf;
                    totalUnits += units;
                  }
                }
              }
            }
          })
        }
      }

      if (totalUnits > 0 && showBlendedPsf == true) {
        return (totalWeightedPsf / totalUnits).toFixed(2);
      }
    },
    totals() {
      const data = this.utcInfo;
      const allSplits = Object.values(data)
        .flatMap((project) => Object.values(project))
        .flatMap((entry) => entry.project_split);

      // Create an array of objects with total units per gut
      const totalsMap = allSplits.reduce((acc, split) => {
        const gut = split.gut;
        const units = Number(split.units) || 0;

        if (!acc[gut]) acc[gut] = 0;
        acc[gut] += units;

        return acc;
      }, {});

      const result = Object.entries(totalsMap).map(([gut, units]) => ({
        general_unit_type: gut,
        total_units: units,
      }));
      return result;
    },
  },
  data() {
    return {
      selectedProject: '',
      landInfo: {},
      selectedDateMap: {},
      totalInfo: {},
      gInfo: this.groupInfo,
      uInfo: this.utcInfo,
      data_fid: this.fid,
    };
  },
  created() {
    this.landInfo = this.groupInfo && this.groupInfo.ptc ? this.groupInfo.ptc.land_info : {};
    this.totalInfo = this.groupInfo && this.groupInfo.ptc ? this.groupInfo.ptc.total_data : [];

    const tempMap = {};
    Object.keys(this.landInfo).forEach((key) => {
      const regData = this.landInfo[key].reg;
      if (regData && Object.keys(regData).length > 0) {
        const firstDateKey = Object.keys(regData)[0];
        tempMap[key] = {
          "selectedDate": firstDateKey,
        };
      }
    });
    this.selectedDateMap = tempMap;
  },
  mounted() {
  },
  methods: {
    showMarketDetails(projectName) {
      if (this.selectedProject == projectName) {
        this.selectedProject = ''
      } else {
        this.selectedProject = projectName
      }
    },
    showBlendedPsf(projectSplit) {
      var res = false;
      var totalWeightedPsf = 0
      var totalUnits = 0

      for (const splitItem of projectSplit) {
        if (Object.keys(splitItem.attr).length == 0) {
          break;
        }
        if (splitItem.attr && splitItem.units) {
          const attrKeys = Object.keys(splitItem.attr);
          if (attrKeys.length > 0) {
            const lastAttrKey = attrKeys[attrKeys.length - 1];
            const lastAttr = splitItem.attr[lastAttrKey];
            const units = parseFloat(splitItem.units);
            const avgPsf = parseFloat(lastAttr.avg_psf);

            totalWeightedPsf += units * avgPsf;
            totalUnits += units;
            if ([lastAttr.avg_price, lastAttr.avg_psf, lastAttr.avg_size].some(val => [null, '', '-'].includes(val))) {
              res = false
              break
            }
            res = Number(totalWeightedPsf / totalUnits).toFixed(2)
          }
        }
      }
      console.log(res, projectSplit)
      return res
    },
    getLatestHistory(data) {
      return data.map(item => {
        const keys = Object.keys(item.attr);
        const lastTimestamp = keys[keys.length - 1];
        return {
          gut: item.gut,
          attr: item.attr[lastTimestamp]
        }
      })
    },
    getPermits(permits) {
      let origin = permits;
      var customOrder = { rd: 0, dp: 1, bp: 2 };
      const sortedEntries = Object.entries(origin).sort(
        (a, b) => customOrder[a[0]] - customOrder[b[0]]
      );
      return sortedEntries;
    },
    shouldActive(key) {
      var key = key.replace(/^[^-]+-/, "");
      return this.data_fid == key;
    },
    setColor: function (data) {
      let color = "";
      if (data) {
        switch (data.toLocaleLowerCase()) {
          case "in planning":
            color = "#244260";
            break;

          case "selling soon":
            color = "#3c6289";
            break;

          case "leasing soon":
            color = "#969191";
            break;

          case "now selling":
            color = "#6c90b6";
            break;

          case "now leasing":
            color = "#b8b0b0";
            break;

          case "sold out":
            color = "#a1bcd8";
            break;

          case "leased out":
            color = "#d4d2d2";
            break;

          default:
            color = "#000";
            break;
        }
      }
      return color;
    },
    keyIsInt: function (key) {
      return !isNaN(parseInt(key));
    },
    selectedDateSwitch: function (value, propertyName) {
      this.selectedDateMap = Object.assign({}, this.selectedDateMap, {
        [propertyName]: { selectedDate: value },
      });
    },
    statusSwitch(status) {
      switch (status) {
        case "Denied":
          return "status-red";
          break;
        case "Not Submitted":
          return "status-grey";
          break;
        case "In Process":
          return "status-yellow";
          break;
        case "Approved":
          return "status-purple";
          break;
        case "Issued":
          return "status-blue";
          break;
        case "Completed":
          return "status-green";
          break;
        default:
          return "status-transparent";
          break;
      }
    },
    getColor: function (color) {
      switch (color) {
        case "Selling Soon":
          return "status-color-selling-soon";
        case "In Planning":
          return "status-color-in-planning";
        case "Leasing Soon":
          return "status-color-leasing-soon";
        case "Now Selling":
          return "status-color-now-selling";
        case "Now Leasing":
          return "status-color-now-leasing";
        case "Leased Out":
          return "status-color-leased-out";
        case "Sold Out":
          return "status-color-sold-out";
        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
tr:last-child {
  border-bottom: 1px solid #dee2e6;
}

.utc-sub {
  display: flex;
}

.utc-item {
  flex-grow: 1;
  text-align: center;
}

.utc-box {
  border: 5px solid #000;
  margin: 5px 15px;
  font-size: 1.3rem;
  min-width: 35rem;
}

.utc-project-name.short {
  /* max-width: 350px; */
}

.utc-project-name {
  min-width: 350px;
  padding: 0 10px;
  min-height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.utc-project-name,
.utc-project-type,
.utc-project-storey {
  border-bottom: 5px solid #000;
}

.utc-project-gut {
  font-weight: bold;
}

.utc-project-gut,
.utc-project-units,
.utc-project-fsr,
.utc-project-gross,
.utc-project-floor,
.utc-project-parking {
  margin: 10px 0;
}

.utc-project-status {
  padding: 10px 0;
  border-top: 5px solid #000;
}

.city-plan {
  height: 25px;
  position: absolute;
  top: 0;
  width: 100%;
  margin-top: 0px;
  background: #79b8f2;
  display: block;
  margin-left: -10px;
  margin-right: -10px;
}

.status-color-selling-soon {
  background: #5f6dff;
}

.status-color-in-planning {
  background: #e7ce1c;
}

.status-color-leasing-soon {
  background: #1227fa;
}

.status-color-now-selling {
  background: #008000;
}

.status-color-now-leasing {
  background: #5db05d;
}

.status-color-leased-out {
  background: #e3676f;
}

.status-color-sold-out {
  background: #c2131e;
}

.unit-value {
  background-color: #e9ecef;
  /* bg-gray-100 equivalent */
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
}

.project-card-vue {
  transition: all 0.3s ease-in-out;
}

.project-card-vue:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  /* Bootstrap's shadow-lg equivalent */
}

.custom-card-body {
  max-width: 100%;
  margin: 0 auto;
  padding: 10px;
  width: 32vw;
}

.card-header {
  background: none;
  padding: 30px 20px 0px 20px;
  border: 0;
}
</style>
